import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Annuler la commande',
  title: 'Ne refusez jamais à la légère !',
  text: 'En cas de problème mineur, appelez le client et réglez-le.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Articles en rupture de stock',
    [OrderRejectionReason.ClosingSoon]: 'Établissement fermé',
    [OrderRejectionReason.StoryBusy]: 'Établissement trop occupé',
    [OrderRejectionReason.CustomerMistake]: 'Le client a appelé pour annuler',
    [OrderRejectionReason.DriverNotArrived]: 'Livreur non arrivé',
  },
  buttons: {
    confirm: 'Confirmer',
  },
};
